import DataInfo from './DataInfo.js'

class DataCenter {
    static _inst = null;
    static getInstance() {
        if (!DataCenter._inst) DataCenter._inst = new DataCenter();
        return DataCenter._inst;
    }
    static createDictionary(code, config, dict) {
        return DataCenter.getInstance().createDictionary(code, config || {}, dict);
    }

    _dictMap = new Map();

    createDictionary(code, config, dict) {
        if (dict instanceof Array) {
            const dataInfo = new DataInfo(code, config, dict);
            this._dictMap.set(code, dataInfo);
            return dataInfo;
        // } else if (dict instanceof Dictionary) {
        //     this._dictMap.set(code, new DataInfo(dict, config));
        } else {
            if (dict) config.dataUrl = dict;
            const dataInfo = new DataInfo(code, config);
            this._dictMap.set(code, dataInfo);
            return dataInfo;
        }
    }
    getDictionary(code) {
        return this._dictMap.get(code) || null;
    }

    async queryData(code, queryParams) {
        const dataInfo = this.getDictionary(code);
        return dataInfo ? dataInfo.queryData(queryParams) : null;
    }
    async getByKeys(code, keys) {
        const dataInfo = this.getDictionary(code);
        return dataInfo ? dataInfo.getByKeys(keys) : null;
    }
}

export default DataCenter;